<template>
  <div>
    <div>
      <Titulo titulo="Informes - Subir Archivos" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div style="margin: 1% 8% 5% 11% !important;">
      <h3 class="color-secundary">Ver Informe</h3>
      <p class="mb-4 text-justify">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum, pariatur quod. Quia aperiam
        sint rerum quos! Beatae aut placeat, inventore a mollitia nobis suscipit eius vitae voluptate
        voluptatibus. Autem, nam.
      </p>

      <table-component :data="informe.data">
        <table-column slot="label" :label="'Cédula'" v-bind:value="'cedula_nit'"></table-column>
        <table-column slot="label" :label="'Cliente'" v-bind:value="'nombre'"></table-column>
        <table-column slot="label" :label="'Convenio'" v-bind:value="'convenio'"></table-column>
        <table-column slot="label" :label="'Pagaré'" v-bind:value="'numero_pagare'"></table-column>
        <table-column slot="label" :label="'Valor Desembolsado'" v-bind:value="'vlr_monto_des'"></table-column>
        <table-column slot="label" :label="'Fecha desembolso'" v-bind:value="'fecha_desembolso'"></table-column>
        <table-column slot="label" :label="'Fecha vencimiento'" v-bind:value="'fecha_vencimiento'"></table-column>
        <table-column slot="label" :label="'Plazo'" v-bind:value="'plazo'"></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: ""
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn")
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading"
    }),
    rows() {
      return this.TablaEstadoProceso.length;
    },
    informe() {
      return this.$store.getters["pages/Informes"].find(
        informe => informe.id == this.$router.currentRoute.params.id
      );
    },
    informeKey() {
      return this.$store.getters["pages/Informes"].findIndex(
        informe => informe.id == this.$router.currentRoute.params.id
      );
    }
  },
  methods: {
    clickEvent() {}
  },
  mounted() {
    /*this.$store.dispatch('pages/fetch', {endpoint: this.informe.endpoint})
    .then((response) => {
      this.$store.commit('pages/SET_INFORMES', {id: this.informeKey, data: response.datos})
    }).catch(error => {

    })*/
  }
};
</script>